import React from 'react';
import { useState } from 'react';
import PropTypes from 'prop-types';
import { InputGroup, InputGroupText, Input } from 'twyne-new.ui';
import { useEffect } from 'react';

const propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
};

const TWYDOM = '.api.twyne.io'
export default function TwyneURL({ value, onChange, ...props }) {
  const [url, setURL] = useState(value)
  const [client, setClient] = useState(null)

  useEffect(() => {
    try {
      const u = new URL(value.includes('http') ? value : `//${value}`, 'https://www')
      if (u.hostname.includes(TWYDOM)) {
        setClient(u.hostname.replace(TWYDOM, ''))
      } else {
        setClient('')
      }
    } catch (e) { }
  }, [])

  useEffect(() => {
    client !== null && setURL(client && `https://${client}${TWYDOM}`)
  }, [client])

  useEffect(() => {
    url != value && onChange(url)
  }, [url, value])

  const handleChange = (e) => {
    setClient(e.target.value || '')
  }

  return <InputGroup>
    <InputGroupText addonType="prepend">https://</InputGroupText>
    <Input step="1" value={client || ''} onChange={handleChange} {...props}/>
    <InputGroupText addonType="append">{TWYDOM}</InputGroupText>
  </InputGroup>
}

TwyneURL.propTypes = propTypes
TwyneURL.defaultProps = {}